enum AcademicCardTypeEnum
{
    ISIC = 'ISIC',
    ISIC_SCHOLAR = 'ISIC_SCHOLAR',
    ITIC = 'ITIC',
    IYTC = 'IYTC',
    ALIVE = 'ALIVE',
}

export default AcademicCardTypeEnum;
